
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiShipSailboat as ObiShipSailboatElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ship-sailboat.js';
 
 
 

 
 export const ObiShipSailboat = createComponent({
   react: React,
   tagName: 'obi-ship-sailboat',
   elementClass: ObiShipSailboatElement,
   events: {
     
   }
  });
 
 